import GroupAdminBulkUpload from './GroupAdminBulkUpload';
export default GroupAdminBulkUpload;
